import { render, staticRenderFns } from "./invitation_code_detail.vue?vue&type=template&id=54c5593a&scoped=true&"
import script from "./invitation_code_detail.vue?vue&type=script&lang=js&"
export * from "./invitation_code_detail.vue?vue&type=script&lang=js&"
import style0 from "./invitation_code_detail.vue?vue&type=style&index=0&id=54c5593a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5593a",
  null
  
)

export default component.exports